/**
 * Component; X_Ajax_WP_Query
 *
 * @uses fetch
 */

/**
 * Capsulate functionality
 */
 const co_ajax_wp_query = function(args) {

  var ajaxQueryState = '';
  var el = {};

  /**
   * Validate args
   */
  if (args.wrapper === null) {
    console.log('Invalid AJAX component');
    return;
  }

  /**
   * Helper: Insert node after other node
   */
  function _el_insert_after(new_node, reference_node) {
    reference_node.parentNode.insertBefore(new_node, reference_node.nextSibling);
  }

  /**
   * Helper: Return $_GET variable by key
   */
  function _get_parameter_by_name(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  /**
   * Helper: Update URL query string $_GET variable
   *
   * @see https://stackoverflow.com/a/6021027
   */
  function _update_query_string_parameter(uri, key, value) {
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      return uri + separator + key + "=" + value;
    }
  }


  const _setup_hooks = () => {

    /**
     * AJAX executer
     *
     * @param array params
     */
    var run = (params) => {

      // prevent simultation requests
      if (ajaxQueryState !== 'fetching') {
        ajaxQueryState = 'fetching';

        // set ajax "state"
        el.wrapper.classList.add('state--loading');
        if (params.replace_items) {
          el.wrapper.classList.add('state--loading-big');
        }

        if (el.announcer) {
          const announcerLoading = el.announcer.querySelector('.js-co-ajax__announcer__loading');
          const announcerReady = el.announcer.querySelector('.js-co-ajax__announcer__ready');
          if (announcerLoading && announcerReady) {
            announcerLoading.classList.add('is-active');
            announcerReady.classList.remove('is-active');
          }
        }

        fetch(params.target_url)
          .then(function (response) {
            return response.text();
          })
          .then(function (rawHTML) {

            /**
             * Parse response into HTML DOM
             */
            let parser = new DOMParser();
            let html = parser.parseFromString(rawHTML, "text/html");

            let new_wrapper = html.querySelector(args.selector_wrapper);

            if (new_wrapper === null) {
              console.log('Invalid response. No wrapper found.');
              return;
            }

            let data = {
              'wrapper'              : new_wrapper,
              'items'                : new_wrapper.querySelector(args.selector_items),
              'pagination_container' : new_wrapper.querySelector(args.selector_pagination_container),
              'pagination'           : new_wrapper.querySelector(args.selector_pagination),
              'pagination_numeric'   : new_wrapper.querySelector(args.selector_pagination_numeric),
              'options'              : new_wrapper.querySelector(args.selector_options),
              'filters'              : new_wrapper.querySelector(args.selector_filters),
              'filter'               : new_wrapper.querySelectorAll(args.selector_filter),
              'filter_items'         : new_wrapper.querySelectorAll(args.selector_filter_items),
              'resets'               : new_wrapper.querySelector(args.selector_resets),
              'reset_items'          : new_wrapper.querySelectorAll(args.selector_reset_items),
              'form'                 : new_wrapper.querySelector(args.selector_form),
              'progress'             : new_wrapper.querySelector(args.selector_progress)
            };

            /**
             * Replace title with target title
             */
            document.title = html.title;

            /**
             * Set URL for browser history
             */
            if (window.history.replaceState) {
              window.history.replaceState({}, document.title, params.replace_url);
            }

            /**
             * Update URL for forms
             */
            if (el.form && data.form) {
              const form = el.form.querySelector('form');
              const newForm = data.form.querySelector('form');
              if (form && newForm) {
                form.setAttribute('action', newForm.getAttribute('action'));
              }
            }

            /**
             * Handle items
             */
            if (data.items) {

              // add entrance effect
              let children = data.items.childNodes;

              for (let i = 0; i < children.length; i++) {
                if (typeof children[i].classList !== 'undefined') {
                  children[i].classList.add('animation--entrance');
                }
              }
              if (params.replace_items) {
                el.items.classList.add('animation--entrance');
                el.items.innerHTML = data.items.innerHTML;
              } else {
                el.items.innerHTML += data.items.innerHTML;
              }

            }

            /**
             * Handle filters
             */
            if (data.filters && el.filters) {
              el.filters.innerHTML = data.filters.innerHTML;
            }

            /**
             * Handle resets
             */
            if (data.resets && el.resets) {
              el.resets.innerHTML = data.resets.innerHTML;
            } else if (el.resets) {
              el.resets.innerHTML = '';
            }

            // @todo replace links

            /**
             * Pagination
             */
            if (params.is_pagination === true) {
              if (data.pagination && el.pagination) {
                el.pagination.href = data.pagination.href;
                el.wrapper.classList.remove('state--no-more-results');
              } else {
                el.wrapper.classList.add('state--no-more-results');
              }
            } else {
              // remove existing button
              el.wrapper.classList.remove('state--no-more-results');
              if (el.pagination_container) {
                el.pagination_container.remove();
              }
              if (data.pagination_container) {
                _el_insert_after(data.pagination_container, el.items);
              }

            }

            // Reset hooks for new and old elements
            _setup_hooks();

            // Remove ajax "state"
            el.wrapper.classList.remove('state--loading');
            el.wrapper.classList.remove('state--loading-big');

            // announce new content
            if (el.announcer) {
              const announcerLoading = el.announcer.querySelector('.js-co-ajax__announcer__loading');
              const announcerReady = el.announcer.querySelector('.js-co-ajax__announcer__ready');
              if (announcerLoading && announcerReady) {
                announcerLoading.classList.remove('is-active');
                announcerReady.classList.add('is-active');
              }
            }

            /**
             * Scroll to results
             */
            if (el.options && params.replace_items) {
              el.options.scrollIntoView();

              // prevent fixed menus from overlapping
              setTimeout(() => {
                const headroomedElement = document.querySelector('.headroom--pinned');
                if (headroomedElement && window.outerHeight + 200 < document.body.outerHeight) {
                  headroomedElement.classList.remove('headroom--pinned');
                  headroomedElement.classList.add('headroom--unpinned');
                }
              }, 100);

            }

            /**
             * Animation time
             */
            setTimeout(function() {
              let animation_items = document.querySelectorAll('.animation--entrance');
              if (animation_items.length) {
                for (let i = animation_items.length - 1; i >= 0; i--) {
                  if (typeof animation_items[i].classList !== 'undefined') {
                    // stagger item animations
                    setTimeout(function(item) {
                      item.classList.remove('animation--entrance');
                    }, 25 * parseInt(i), animation_items[i]);
                  }
                }
              }
            }, 75);
            ajaxQueryState = '';
          })
          .catch(function (error) {
            console.log(error);
            ajaxQueryState = '';
          });

      }

    };

    /**
     * Handle pagination
     */
    const trigger_pagination = function(e) {

      e.preventDefault();
      let current_url = window.location.href.replace(location.hash,"");
      let loar_arg = e.currentTarget.getAttribute('data-load-param');
      let load_val = _get_parameter_by_name(loar_arg);
      if (typeof load_val === 'object') {
        load_val = 1;
      }

      run({
        'target_url'    : e.currentTarget.getAttribute('data-href'),
        'replace_url'   : _update_query_string_parameter(current_url, loar_arg, parseInt(load_val) + 1),
        'replace_items' : false,
        'is_pagination' : true
      });

    };

    /**
     * Handle numeric pagination
     */
    const trigger_numeric_pagination = function(e) {

        e.preventDefault();

        run({
          'target_url'    : e.currentTarget.getAttribute('href'),
          'replace_url'   : e.currentTarget.getAttribute('href'),
          'replace_items' : true,
          'is_pagination' : false // force full load
        });

    };

    /**
     * Handle filtering
     */
    const trigger_filter = function(e) {
      e.preventDefault();

      // toggle active class
      let current_active = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.co-ajax__filter__item__link--active');
      if (current_active) {
        current_active.classList.remove('co-ajax__filter__item__link--active');
      }
      e.currentTarget.classList.add('.co-ajax__filter__item__link--active');

      // add button label
      let button = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.js-co-ajax__filter__toggle');
      if (button) {
        button.textContent = e.currentTarget.textContent;
      }

      run({
        'target_url'    : e.currentTarget.getAttribute('data-href'),
        'replace_url'   : e.currentTarget.getAttribute('data-href'),
        'replace_items' : true
      });

    };

    /**
     * Handle reset
     */
    const trigger_reset = function(e) {

      e.preventDefault();

      run({
        'target_url'    : e.currentTarget.getAttribute('data-href'),
        'replace_url'   : e.currentTarget.getAttribute('data-href'),
        'replace_items' : true
      });

    };

    /**
     * Trigger filter list toggle
     */
    const trigger_filter_toggle = function(e) {
      if (e.currentTarget.getAttribute('aria-expanded') == 'false') {
        e.currentTarget.setAttribute('aria-expanded', 'true');
      } else {
        e.currentTarget.setAttribute('aria-expanded', 'false');
      }
    };

    /**
     * Handle forms
     */
    const trigger_form = function(form) {

      let url = '';
      let url_params = [];

      const formElement = form.querySelector('form');

      for (const input of form.querySelectorAll('input')) {

        let id = String(input.getAttribute('name'));
        if (url_params[id] === undefined) {
          url_params[id] = [];
        }
        switch (input.getAttribute('type')) {
          case 'text':
            if(input.value !== null && input.value !== undefined && input.value !== '') {
              url_params[id].push(input.value);
            }
            break;

          default:
            break;
        }
      }

      for (const select of form.querySelectorAll('select')) {

        let id = String(select.getAttribute('name'));
        if (url_params[id] === undefined) {
          url_params[id] = [];
        }

        if(select.value != null && select.value !== undefined && select.value !== '') {
          url_params[id].push(select.value);
        }
      }


      let url_params_string = '';
      for (const [key, value] of Object.entries(url_params)) {
        if (value.length > 0) {
          if (url_params_string === '') {
            url_params_string = key + '=' + value;
          } else {
            url_params_string += key + '=' + value;
          }
        }
      }

      if (formElement && formElement.getAttribute('action')) {
        url = formElement.getAttribute('action');
      } else {
        url = document.location.href.split('?')[0];
      }

      // add ? or & based on if url has parameters
      if (url_params_string) {
        if (url.indexOf('?') !== -1) {
          url += '&' + url_params_string;
        } else {
          url += '?' + url_params_string;
        }
      }

      run({
        'target_url'    : url,
        'replace_url'   : url,
        'replace_items' : true,
      });
    };

    // setup elements on current page
    el = {
      'wrapper'                         : args.wrapper,
      'items'                           : args.wrapper.querySelector(args.selector_items),
      'pagination_container'            : args.wrapper.querySelector(args.selector_pagination_container),
      'pagination'                      : args.wrapper.querySelector(args.selector_pagination),
      'pagination_numeric'              : args.wrapper.querySelector(args.selector_pagination_numeric),
      'filter_toggles'                  : args.wrapper.querySelectorAll(args.selector_filter_toggles),
      'filter_items'                    : args.wrapper.querySelectorAll(args.selector_filter_items),
      'options'                         : args.wrapper.querySelector(args.selector_options),
      'announcer'                       : args.wrapper.querySelector(args.selector_announcer),
      'resets'                          : args.wrapper.querySelector(args.selector_resets),
      'reset_items'                     : args.wrapper.querySelectorAll(args.selector_reset_items),
      'filters'                         : args.wrapper.querySelector(args.selector_filters),
      'filter'                          : args.wrapper.querySelectorAll(args.selector_filter),
      'form'                            : args.wrapper.querySelector(args.selector_form),
      'progress'                        : args.wrapper.querySelector(args.selector_progress)
    };

    // hook events to elements
    if (el.pagination !== null) {
      el.pagination.addEventListener('click', trigger_pagination);
    }
    if (el.pagination_numeric !== null) {
      const numeric_links = el.pagination_numeric.querySelectorAll('a');
      for (let i = 0; i < numeric_links.length; i++) {
        numeric_links[i].addEventListener('click', trigger_numeric_pagination);
      }
    }
    if (el.form !== null) {
      let trigger_timer;
      if (!el.form.classList.contains('is-inited')) {
        el.form.addEventListener('submit', (e) => {
          e.preventDefault();
          trigger_form(el.form);
          clearTimeout(trigger_timer);
        });
        el.form.classList.add('is-inited');
      }

      let form_filters = el.form.querySelectorAll('.js-co-ajax__form__filter');
      for (const form_filter of form_filters) {
        if (form_filter !== null && !form_filter.classList.contains('is-inited')) {
          form_filter.addEventListener('change', () => {
            clearTimeout(trigger_timer);
            trigger_timer = setTimeout(() => {
              trigger_form(el.form);
            }, 1000);
          });
          form_filter.classList.add('is-inited');
        }
      }
    }
    if (el.filter_items.length) {
      for (let i = 0; i < el.filter_items.length; i++) {
        el.filter_items[i].addEventListener('click', trigger_filter);
      }
    }
    if (el.filter.length) {
      for (let i = 0; i < el.filter.length; i++) {
        const filterSkipButton = el.filter[i].querySelector('.js-co-ajax__filter__skip');
        const filterSkipTarget = el.filter[i].querySelector('.js-co-ajax__filter__skip-target');
        if (filterSkipTarget && filterSkipButton) {
          filterSkipButton.addEventListener('click', (e) => {
            filterSkipTarget.setAttribute('tabindex', '0');
            filterSkipTarget.setAttribute('aria-hidden', 'false');
            filterSkipTarget.focus();
          });
          filterSkipTarget.addEventListener('blur', (e) => {
            e.currentTarget.removeAttribute('tabindex');
            e.currentTarget.setAttribute('aria-hidden', 'true');
          });
        }
      }
    }
    if (el.options) {
      const optionsSkipButton = el.options.querySelector('.js-co-ajax__filter-skip-all');
      const optionsSkipTarget = el.options.querySelector('.js-co-ajax__filter-skip-all-target');
      if (optionsSkipButton && optionsSkipTarget) {
        optionsSkipButton.addEventListener('click', (e) => {
          optionsSkipTarget.setAttribute('tabindex', '0');
          optionsSkipTarget.setAttribute('aria-hidden', 'false');
          optionsSkipTarget.focus();
        });
        optionsSkipTarget.addEventListener('blur', (e) => {
          e.currentTarget.removeAttribute('tabindex');
          e.currentTarget.setAttribute('aria-hidden', 'true');
        });
      }
    }
    if (el.reset_items.length) {
      for (let i = 0; i < el.reset_items.length; i++) {
        el.reset_items[i].addEventListener('click', trigger_reset);
      }
    }
    if (el.filter_toggles.length) {
      for (let i = 0; i < el.filter_toggles.length; i++) {
        el.filter_toggles[i].addEventListener('click', trigger_filter_toggle);
      }
    }

  };

  _setup_hooks();

  // make the call chainable
  return this;
};

const co_ajax_wp_query_init = () => {

  const components = document.querySelectorAll('.js-co-ajax');
  if (components.length) {
    for (let i = 0; i < components.length; i++) {

      co_ajax_wp_query({
        'selector_wrapper'                : '#' + components[i].getAttribute('id'),
        'selector_items'                  : '.js-co-ajax__items',
        'selector_pagination_container'   : '.js-co-ajax__pagination',
        'selector_pagination'             : '.js-co-ajax__pagination__button',
        'selector_pagination_numeric'     : '.js-co-ajax__numeric-pagination',
        'selector_options'                : '.js-co-ajax__options',
        'selector_announcer'              : '.js-co-ajax__announcer',
        'selector_filters'                : '.js-co-ajax__filters',
        'selector_filter'                 : '.js-co-ajax__filter',
        'selector_resets'                 : '.js-co-ajax__resets',
        'selector_reset_items'            : '.js-co-ajax__resets__item',
        'selector_filter_items'           : '.js-co-ajax__filter__item__link',
        'selector_filter_toggles'         : '.js-co-ajax__filter__toggle',
        'selector_form'                   : '.js-co-ajax__form',
        'selector_progress'               : '.js-co-ajax__progress',
        'wrapper'                         : components[i]
      });

    }
  }
};

/**
 * Initiate automatically
 */
document.addEventListener('DOMContentLoaded', function() {
  co_ajax_wp_query_init();
});
